import React from 'react';
import { Check } from 'lucide-react';
export const Academy = () => {
  return <section id="academia" className="py-16 bg-beige-50 relative overflow-hidden" data-id="element-20">
      {/* Subtle gold glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-[radial-gradient(ellipse_at_top,_rgba(201,166,107,0.22),_transparent_70%)] pointer-events-none" data-id="element-21"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-22">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-23">
          <div data-id="element-24">
            <h2 className="text-sm tracking-widest uppercase mb-2 font-[800] text-center text-[#5C4A3A]" data-id="element-25">
              ¿Quieres convertir tu pasión en un{' '}
              <span className="metallic-gold-text-static" data-id="element-26">negocio</span>?
            </h2>
            <h3 className="text-3xl md:text-4xl font-serif mb-6 text-neutral-900" data-id="element-27">
              <span className="metallic-gold-text" data-id="element-28">
                Academia de Alisados Orgánicos NY
              </span>
            </h3>
            <p className="text-neutral-700 text-lg mb-8 font-light" data-id="element-29">
              Stefania también certifica a profesionales y emprendedoras que
              quieren dominar las técnicas de alisados orgánicos y construir su
              propio negocio de belleza.
            </p>

            <div className="space-y-3 mb-8" data-id="element-30">
              {['Aplicación profesional de alisados orgánicos', 'Botox capilar técnico', 'Restauración capilar con moléculas reparadoras', 'Diagnóstico capilar correcto'].map((item, idx) => <div key={idx} className="flex items-center" data-id="element-31">
                  <div className="w-6 h-6 bg-gold-100 border border-gold-300 rounded-full flex items-center justify-center mr-3" data-id="element-32">
                    <Check className="w-4 h-4 metallic-gold-icon" data-id="element-33" />
                  </div>
                  <span className="font-medium text-neutral-800" data-id="element-34">{item}</span>
                </div>)}
            </div>

            <p className="font-serif text-xl italic mb-8 text-neutral-700" data-id="element-35">
              Convierte tu pasión en libertad financiera.
            </p>

            <a href="https://wa.me/13479909488?text=Hola%2C%20me%20gustar%C3%ADa%20informaci%C3%B3n%20sobre%20la%20Academia%20%E2%9C%A8" target="_blank" rel="noopener noreferrer" className="inline-block metallic-gold-button text-white px-8 py-3 rounded-full font-medium shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-36">
              Conoce la Academia
            </a>
          </div>

          <div className="relative flex justify-center md:justify-end" data-id="element-37">
            {/* Soft gold glow behind portrait */}
            <div className="absolute -inset-6 rounded-[2.5rem] pointer-events-none" style={{
            background: 'radial-gradient(ellipse at center, rgba(201,166,107,0.28), transparent 70%)'
          }} aria-hidden="true" data-id="element-38" />

            {/* Decorative offset ring */}
            <div className="absolute -top-5 -left-5 w-32 h-32 rounded-full border border-gold-400/50 hidden sm:block" aria-hidden="true" data-id="element-39" />
            <div className="absolute -bottom-6 -right-4 w-24 h-24 rounded-full bg-beige-100/60 border border-gold-300/40 hidden sm:block" aria-hidden="true" data-id="element-40" />

            {/* Portrait frame */}
            <div className="relative rounded-[2rem] overflow-hidden border-2 border-gold-300 bg-beige-100" style={{
            boxShadow: '0 30px 70px -20px rgba(120, 80, 30, 0.35), 0 12px 30px -8px rgba(120, 80, 30, 0.2)'
          }} data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/j2UuxQbkpLj93KHisicgMb/stefa.png" alt="Stefania Becerra, fundadora de la Academia de Alisados Orgánicos NY" className="w-full h-auto max-w-sm object-cover block" data-id="element-42" />
              {/* Subtle bottom gradient for badge legibility */}
              <div className="absolute inset-x-0 bottom-0 h-32 pointer-events-none" style={{
              background: 'linear-gradient(to top, rgba(60,46,34,0.55), transparent)'
            }} aria-hidden="true" data-id="element-43" />
              {/* Floating brand badge */}
              <div className="absolute bottom-5 left-1/2 -translate-x-1/2 text-center px-6 py-2 rounded-full bg-white/90 backdrop-blur-sm border border-gold-300 shadow-lg" data-id="element-44">
                <span className="block font-serif italic text-xl leading-none metallic-gold-text" data-id="element-45">
                  Master Class
                </span>
                <span className="block font-serif tracking-widest uppercase text-[10px] mt-0.5 metallic-gold-text-static" data-id="element-46">
                  Profesional
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};